import { Client, HttpMethod, Hub, Project } from '@bimone/bimtrack-core';
import ProjectAssembler from './assemblers/ProjectAssembler';
import { ProjectDto } from './assemblers/types';

export default class ProjectClient {
  public constructor(
    private readonly bimTrackApiUrl: string,
    private readonly token?: string,
    private readonly signal?: AbortSignal,
    private readonly timeOutMs?: number
  ) {}

  public async fetchProjects(hubOrHubHashId: Hub | string): Promise<Project[]> {
    const hub = hubOrHubHashId as Hub;
    const client = new Client<ProjectDto[]>({
      baseUrl: this.bimTrackApiUrl,
      endpoint: `v3/hubs/${hub.hashId ?? hub.id ?? hubOrHubHashId}/projects`,
      token: this.token,
      signal: this.signal,
      timeOutMs: this.timeOutMs,
    });

    const projectsDto = await client.sendRequest(HttpMethod.GET);

    return projectsDto.map((projectDto: ProjectDto) => ProjectAssembler.toDomain(projectDto));
  }
}
